import React, {Fragment, useEffect, useState} from 'react'// eslint-disable-line
import {WidgetHeader} from '../../components/common/widget-header';
import clsx from 'clsx';
import {currencyNames} from '../../utils/currency-names';
import {
  currencyFormatter,
  dateFormatter,
  getSavedLocation,
  getUrlParameters, isToday
} from '../../utils/helpers';
import apiEntryPoint from '../../api/apiSingleton';
import {DEFAULT_CURRENCIES_LIST} from '../../utils/constants';
import {Loader} from '../../components/common/loader';
import {sortObject} from '../../utils/sort-object';
import {useStyles} from './style';

const getSavedDate = getUrlParameters('date') ? new Date(getUrlParameters('date')) : new Date();
const initialData = {
  loading: true,
  data: []
};

export const BestRates = () => {
  const [bestCurrenciesData, setBestCurrenciesData] = useState(initialData);
  const [requestData, setRequestData] = useState({
    currencies: DEFAULT_CURRENCIES_LIST,
    date: dateFormatter(getSavedDate),
    city: getSavedLocation().key
  });
  const classes = useStyles();

  const requestedDataHandler = ({detail}) => {
    setRequestData({...requestData, ...detail});
  };

  useEffect(() => {
    window.addEventListener('change-request-currency-params', requestedDataHandler);

    apiEntryPoint.finance.getBestRates(requestData)
      .then(sortObject('code', false))
      .catch(() => [])
      .then(data => setBestCurrenciesData({loading: false, data}));

    return () => {
      window.removeEventListener('change-request-currency-params', requestedDataHandler);
    };
  }, [requestData]);

  const renderBestCurrencies = () => {
    if (!bestCurrenciesData.data.length) {
      return (
        <tr><td colSpan={3} className={classes.textCenter}>Нет данных</td></tr>
      );
    }

    return (
      bestCurrenciesData.data.map(currency => (
        <tr key={currency.code} className={classes.tableRow}>
          <td className={classes.tableColumn}>
            <span className={clsx(classes.currencyFlag, currency.code)}>
              <img
                src={`/${__STATIC_DIRECTORY__}/img/flags/${currency.code.toLowerCase()}.svg`}
                loading='lazy'
                width='30'
                height='22'
                alt={currency.code}
              />
            </span>
            <span className={classes.currencyInfo}>
              <span className={classes.currencyName}>{currencyNames[currency.code]}</span>
              <span className={classes.currencyUnit}>{currency.amount} {currency.code}</span>
            </span>
          </td>
          <td className={clsx(classes.tableColumn, classes.textRight)}>
            <span>{currencyFormatter(currency.buy)}</span>
          </td>
          <td className={clsx(classes.tableColumn, classes.textRight)}>
            <span>{currencyFormatter(currency.sell)}</span>
          </td>
        </tr>
      ))
    );
  };

  return (
    <div className={classes.bestCurrenciesWrapper}>
      <div className={classes.header}>
        <WidgetHeader text={`Лучшие курсы валюты на ${requestData?.date ? isToday(requestData?.date) : 'сейчас'}`} />
      </div>
      <table className={classes.table}>
        {!bestCurrenciesData.loading
          ? (
            <Fragment>
              <thead>
                <tr className={classes.tableHeader}>
                  <th className={classes.tableColumn}>Валюта</th>
                  <th className={clsx(classes.tableColumn, classes.textRight)}>Покупка</th>
                  <th className={clsx(classes.tableColumn, classes.textRight)}>Продажа</th>
                </tr>
              </thead>
              <tbody>
                {renderBestCurrencies()}
              </tbody>
            </Fragment>
          )
          : null
        }
      </table>
      {bestCurrenciesData.loading
        ? <Loader visibility />
        : null
      }
    </div>
  );
};
